<template>
  <div id="app" class="container">
    <div class="row">

        <router-view/>

    </div>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
body{
  font-size:20px;
}
  input{
    border-style:none;
    border-bottom-style:solid;
    padding: 0px 10px;
  }
  .finished{
    width: 100%;
    height:1000px;
  }
  p.template{
    margin-bottom:30px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue